import './style.scss';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

export const InputRange = ({ handleChange, width, valueOverThumb = false, value, min = 0, max = 100, className, ...props }) => {
    const inputClass = classNames(className);
    const [step, setStep] = useState(0);
    const ref = useRef();
    const handleRangeChange = ({ target: range }) => {
        handleChange(range.value);
    };

    useEffect(() => {
        const rangeLinePadding = 15;
        const calcStep = (ref.current.offsetWidth - rangeLinePadding) / (ref.current.max - ref.current.min);
        setStep(calcStep);
    }, []);

    return (
        <div className={classNames("relative custom-input-range", width)}>
            {valueOverThumb && ref.current && (
                <label
                    className="absolute bottom-4 font-medium text-gray-500"
                    style={{
                        transform: `translateX(${value < ref.current.max / 5? value * step + 4 : ref.current.max > 50 || value > ref.current.max - 5 ? value * step - 4: value * step }px)`,
                    }}
                >
                    <span className="text-sm">{value}</span>
                </label>
            )}
            <input className={inputClass} ref={ref} min={min} max={max} value={value} type="range" onChange={handleRangeChange} {...props} />
        </div>
    );
};
